(function (global) {
    define('LNRS/Components/TabSetMobileDropDown',[
        "jquery", "eventManager"
    ], function ($, eventManager) {

        function TabSetMobileDropDown(scope, stateChangeMessages) {
            var self = this;
            Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });

            //#region message transmitter registration
            if (stateChangeMessages.length) {
                this.$scope.on("shown.bs.tab", function () {

                    stateChangeMessages.forEach(function (eventName) {
                        window.console && console.info("TabSet raises message: \'%s\'", eventName);

                        eventManager.trigger(eventName, self);
                    });

                    return false;
                });
            }
            //#endregion

            this.tabContent = this.$scope.find(".tab-content").first();
            this._setupDeepLinking();
        }

        TabSetMobileDropDown.prototype._setupDeepLinking = function () {
            var that = this;

            var btnMenu = this.$scope.find("div.score-button-menu").first();
            var selectedOption = btnMenu.find("span.selected-option").first();
            var tabsDd = btnMenu.find("ul.dropdown-menu").first();
            var tabsNavList = this.$scope.find(".nav").first().children();
            

            tabsNavList.each(function (e, li) {
                tabsDd.append("<li class='score-button-menu-item'>" + li.innerHTML + "</li>");
            }.bind(this));

            selectedOption.text(tabsDd.children().first().text());
            tabsDd.children().first().addClass("active");

            this.$scope.on("show.bs.tab", 'a[data-toggle="tab"][href*="#tab-"]', function (e) {
                this.$paneToShow = this.tabContent.find('div[id="' + e.target.hash.substring(1) + '"]');
            }.bind(this));

            this.$scope.on("shown.bs.tab", 'a[data-toggle="tab"][href*="#tab-"]', function (e) {
                var $li = $(e.target).parent();

                if ($li.hasClass("score-button-menu-item")) {
                    tabsNavList.removeClass("active").find('a[href="' + e.target.hash + '"]').parent().addClass("active");
                } else {
                    tabsDd.children().removeClass("active").find('a[href="' + e.target.hash + '"]').parent().addClass("active");
                }

                $li.siblings().removeClass("active");
                $li.addClass("active");
                selectedOption.text(e.target.text);

                var anchor = "";
                var oldHash = window.location.hash.substring(1);

                if ($(this).is('a[data-toggle="tab"][href*="#tab-"][data-anchorable="true"]')) {
                    anchor = $(this).attr("href").replace("#tab-", "");
                }

                if (anchor) {
                    window.history && window.history.pushState && window.history.pushState(null, null, "#" + anchor);
                    window.location.hash = anchor;
                } else {
                    if (oldHash && $(this).closest(".nav-tabs").find('a[data-toggle="tab"][href*="#tab-' + oldHash + '"][data-anchorable="true"]').length) {
                        window.location.hash = "";
                    }
                }
            }.bind(this));

            $(window).on("hashchange", function () {
                if (!window.location.hash) return !1;
                var tab = that.$scope.find("a[href='#tab-" + window.location.hash.substring(1) + "']");
                if (tab.length) {
                    tab.click();
                    $([document.documentElement, document.body]).animate({
                        scrollTop: 0
                    }, 500);
                }
            });
        }

        return function initTabSetMobileDropDown(args) {
            return args.IsPageEditorEditing === true
                ? null
                : new TabSetMobileDropDown(args.scope, args.StateChangeMessagesTransmitting || []);
        };
    });
})(this);
